module.exports = {"https":{"api":"https://api.xinfushenghuo.cn"},"newhttps":{"api":"https://monitor.9buqi.cn"},"staticPro":{"api":"https://static.xinfushenghuo.cn"},"BJLogin":{"api":"https://loginf.lawxp.com"},"BJapi1":{"api":"https://api1.xinfushenghuo.cn"},"BJapi2":{"api":"http://api2.xinfushenghuo.cn"},"newHttps":{"api":"https://monitor.9buqi.cn/v1"},"BJOAlogin":{"api":"https://timeapi.lawxp.com"},"admin":"https://www.9buqi.com/business/login"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/config.json
// module id = 2LA7
// module chunks = 14